import { render, staticRenderFns } from "./Demanda.vue?vue&type=template&id=4df42325"
import script from "./Demanda.vue?vue&type=script&lang=js"
export * from "./Demanda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports